/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */
import React from "react";
import { classNames } from "@plasmicapp/react-web";

export function Icon24Icon(props) {
  const { className, style, title, ...restProps } = props;
  return (
    <svg
      xmlns={"http://www.w3.org/2000/svg"}
      version={"1.1"}
      viewBox={"0 0 1024 1024"}
      className={classNames("plasmic-default__svg", className)}
      style={style}
      {...restProps}
    >
      {title && <title>{title}</title>}

      <path
        fill={"#fff"}
        d={
          "M805.17 721.1C739.99 812.69 632.97 872.44 512 872.44S284.01 812.69 218.82 721.1l87.04-61.82C351.68 723.69 426.94 765.7 512 765.7s160.32-42.01 206.13-106.42z"
        }
      ></path>
    </svg>
  );
}

export default Icon24Icon;
/* prettier-ignore-end */
